/**
 * @generated SignedSource<<aa31b77ba563a4105ea6871710d1f3a6>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type FilterBooleanOperator = "AND" | "NOT" | "OR" | "%future added value";
export type FilterElementInput = {
  multiple?: FilterBooleanOperationInput | null | undefined;
  single?: FilterValueInput | null | undefined;
};
export type FilterValueInput = {
  name: string;
  operator?: string | null | undefined;
  value?: string | null | undefined;
  values?: ReadonlyArray<string | null | undefined> | null | undefined;
};
export type FilterBooleanOperationInput = {
  operands: ReadonlyArray<FilterElementInput>;
  operator: FilterBooleanOperator;
};
export type useResourceMatchCountRefetchQuery$variables = {
  filterElement?: FilterElementInput | null | undefined;
};
export type useResourceMatchCountRefetchQuery$data = {
  readonly " $fragmentSpreads": FragmentRefs<"useResourceMatchCount_query">;
};
export type useResourceMatchCountRefetchQuery = {
  response: useResourceMatchCountRefetchQuery$data;
  variables: useResourceMatchCountRefetchQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "filterElement"
  }
],
v1 = {
  "kind": "Variable",
  "name": "filterElement",
  "variableName": "filterElement"
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "useResourceMatchCountRefetchQuery",
    "selections": [
      {
        "args": [
          (v1/*:: as any*/)
        ],
        "kind": "FragmentSpread",
        "name": "useResourceMatchCount_query"
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Operation",
    "name": "useResourceMatchCountRefetchQuery",
    "selections": [
      {
        "alias": null,
        "args": [
          (v1/*:: as any*/),
          {
            "kind": "Literal",
            "name": "first",
            "value": 1
          }
        ],
        "concreteType": "ResourceMatchConnection",
        "kind": "LinkedField",
        "name": "resourceMatches",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "PageInfo",
            "kind": "LinkedField",
            "name": "pageInfo",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "total",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "f7c243d95c99f252049bdeac63484d9c",
    "id": null,
    "metadata": {},
    "name": "useResourceMatchCountRefetchQuery",
    "operationKind": "query",
    "text": "query useResourceMatchCountRefetchQuery(\n  $filterElement: FilterElementInput\n) {\n  ...useResourceMatchCount_query_2g1q2o\n}\n\nfragment useResourceMatchCount_query_2g1q2o on Query {\n  resourceMatches(first: 1, filterElement: $filterElement) {\n    pageInfo {\n      total\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "7eecbd63d380e088b5b3716356918d8c";

export default node;
